import { Nullable } from '@/shared/types/app.types'

export interface PDFData{
    data: string
}

export interface PDFViewState {
    currentPage: number
    pageCount: number
    pdfData: Nullable<PDFData>
}
export const initialPDFViewState =
    (): PDFViewState => ({
        currentPage: 1,
        pageCount: 0,
        pdfData: null
    })
